import { FirstCallInfo } from '../../../models/pro.model';
import {
  cellBaseStyle,
  fullWidthCellStyle,
  linkColour,
  tableSubHeaderColour,
  tableWidth,
} from '../pro-report-email-styles';
import {
  ProReportEmailFullWidthInfoRow,
  ProReportEmailFullWidthTableHeader,
  Spacer,
} from './pro-report-email-common-components';

function ProReportEmailFirstCallInfo({
  firstCallInfo,
}: {
  firstCallInfo: FirstCallInfo | null;
}) {
  const headerText = 'First Call contact';
  if (firstCallInfo) {
    return (
      <>
        <table
          width={tableWidth}
          cellPadding={0}
          cellSpacing={0}
          style={{ borderCollapse: 'collapse', margin: 0, padding: 0 }}
          role="presentation"
        >
          <ProReportEmailFullWidthTableHeader headerText={headerText} />
          <ProReportEmailFullWidthInfoRow
            heading="Company:"
            content={firstCallInfo.company ?? 'N/A'}
            backgroundColor={tableSubHeaderColour}
          />
          <tr>
            <td
              colSpan={1}
              style={{
                ...cellBaseStyle,
              }}
            >
              <strong>Email: </strong>
              {firstCallInfo.email ? (
                <a
                  href={`mailto:${firstCallInfo.email}`}
                  style={{
                    color: linkColour,
                    textDecoration: 'underline',
                    fontWeight: 'bold',
                  }}
                >
                  {firstCallInfo.email}
                </a>
              ) : (
                'N/A'
              )}
            </td>
            <td
              colSpan={1}
              style={{
                ...cellBaseStyle,
              }}
            >
              <strong>Telephone: </strong>
              {firstCallInfo.telephone ?? 'N/A'}
            </td>
          </tr>
          <tr>
            <td
              colSpan={2}
              style={{
                ...fullWidthCellStyle,
              }}
            >
              <strong>Advice: </strong>For matters involving the disembarkation
              of crew for medical treatment in the USA/Brazil.
            </td>
          </tr>
        </table>
        <Spacer />
      </>
    );
  }
  return null;
}

export default ProReportEmailFirstCallInfo;
